import {
  DeviceType,
  DeviceTypeConfig,
} from '@src/types/devices/DeviceConfig.types';
import { WidgetInternalId } from '@src/types/devices/Widget.types';

export const DEVICE_CONFIGS: Record<DeviceType, DeviceTypeConfig> = {
  [DeviceType.BMS]: {
    widgetIds: {
      list: WidgetInternalId.BMS_LIST,
      detail: WidgetInternalId.BMS_DETAIL,
      children: [
        {
          key: 'rack',
          widgetId: WidgetInternalId.RACK_LIST,
          idPrefix: 'rack',
        },
      ],
    },
    stylePrefix: 'bms',
    errorMessageId: 'Error fetching bms details.',
  },
  [DeviceType.PCS]: {
    widgetIds: {
      list: WidgetInternalId.PCS_LIST,
      detail: WidgetInternalId.PCS_DETAIL,
      children: [
        {
          key: 'converter',
          widgetId: WidgetInternalId.PCS_CONVERTER_LIST,
          idPrefix: 'converter',
        },
        {
          key: 'module',
          widgetId: WidgetInternalId.PCS_MODULE_LIST,
          idPrefix: 'module',
        },
      ],
    },
    stylePrefix: 'pcs',
    errorMessageId: 'Error fetching pcs details.',
  },
  [DeviceType.PCS_PV]: {
    widgetIds: {
      list: WidgetInternalId.PCS_PV_LIST,
      detail: WidgetInternalId.PCS_PV_DETAIL,
      children: [
        {
          key: 'converter',
          widgetId: WidgetInternalId.PCS_PV_CONVERTER_LIST,
          idPrefix: 'converter',
        },
        {
          key: 'module',
          widgetId: WidgetInternalId.PCS_PV_MODULE_LIST,
          idPrefix: 'module',
        },
      ],
    },
    stylePrefix: 'pcs',
    errorMessageId: 'Error fetching pcs details.',
  },
  [DeviceType.MET]: {
    widgetIds: {
      list: WidgetInternalId.MET_LIST,
      detail: WidgetInternalId.MET_DETAIL,
      children: [
        {
          key: 'converter',
          widgetId: WidgetInternalId.MET_CONVERTER_LIST,
          idPrefix: 'converter',
        },
        {
          key: 'module',
          widgetId: WidgetInternalId.MET_MODULE_LIST,
          idPrefix: 'module',
        },
      ],
    },
    stylePrefix: 'pcs',
    errorMessageId: 'Error fetching MET details.',
  },
};
